import { render } from "./BarChartH.vue?vue&type=template&id=1b1c4098&scoped=true"
import script from "./BarChartH.vue?vue&type=script&lang=ts"
export * from "./BarChartH.vue?vue&type=script&lang=ts"

import "./BarChartH.vue?vue&type=style&index=0&id=1b1c4098&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b1c4098"

export default script